import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Checkbox extends PureComponent {
  render () {
    let label
    if (this.props.label !== undefined) {
      label = <label>{this.props.label}</label>
    }

    let classNames = 'checkbox'
    if (this.props.classNames) {
      classNames += ' ' + this.props.classNames
    }
    if (label) {
      classNames += ' checkbox-with-label'
    }
    return (
      <div className={classNames}>
        {this.props.prependLabel && label}
        <input type="checkbox" checked={this.props.value} onChange={this.props.onChange}/>
        {!this.props.prependLabel && label}
      </div>
    )
  }
}

Checkbox.defaultProps = {
  classNames: 'checkbox-default',
  prependLabel: false
}

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  label: PropTypes.string,
  classNames: PropTypes.string,
  prependLabel: PropTypes.bool
}

export default Checkbox
